function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "shopping_bag"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.068 7.926c-.076-1.08-.985-1.926-2.068-1.926h-1c0-2.206-1.794-4-4-4s-4 1.794-4 4h-1c-1.083 0-1.992.846-2.068 1.926l-.858 12.006c-.039.537.147 1.068.509 1.457s.879.611 1.417.611h12c.538 0 1.055-.223 1.417-.611s.548-.92.509-1.457zm-7.068-3.926c1.103 0 2 .897 2 2h-4c0-1.103.897-2 2-2zm-5.926 16 .852-11.932c.002-.025.049-.068.074-.068h1v1c0 .553.447 1 1 1s1-.447 1-1v-1h4v1c0 .553.447 1 1 1s1-.447 1-1v-1h1c.025 0 .072.043.074.068l.877 11.932z"
}));

var Svg104Shoppingbag = function Svg104Shoppingbag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg104Shoppingbag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/104-shopping bag.2988fcc8.svg";
export { ForwardRef as ReactComponent };